module.exports = __webpack_public_path__ + "static/media/kushner-egypt.d6f18db3.png";